//  // When a variant is clicked
//  $('.variant-color').on('click', function() {
//   // Get the data-image from the clicked variant
//   var imageUrl = $(this).data('image');
//   console.log("Image URL " + imageUrl);
//   // Find the closest card-wrapper and inside it, the first image with the class 'media'
//   var cardWrapper = $(this).closest('.product-variants').siblings('.card-wrapper');
  
//   if(cardWrapper.length) {
//     // Find the image inside the 'media' class and update the src attribute
//     cardWrapper.find('.media img').first().attr('src', imageUrl);
//   }
// });


//   // Listen for click events on variant-color elements
//   $('.variant-color').click(function() {
//     // Remove 'active' class from all variant-color elements
//     $('.variant-color').removeClass('active');
    
//     // Add 'active' class to the clicked variant
//     $(this).addClass('active');
//   });
 
// Event delegation for when a variant is clicked
$(document).on('click', '.variant-color', function() {
  // Get the data-image from the clicked variant
  var imageUrl = $(this).data('image');
  console.log("Image URL " + imageUrl);
  // Find the closest card-wrapper and inside it, the first image with the class 'media'
  var cardWrapper = $(this).closest('.product-variants').closest('.card-wrapper');
  
  if(cardWrapper.length) {
    // Find the image inside the 'media' class and update the src attribute
    cardWrapper.find('.media img').first().attr('src', imageUrl);
  }

  // Remove 'active' class from all variant-color elements
  $('.variant-color').removeClass('active');
  
  // Add 'active' class to the clicked variant
  $(this).addClass('active');
});
